import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@app/shared';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { environment } from '@env/environment';
import { PurchaseManagerAnalyticsModule } from './analytics';
import { AnalyticsApiService } from './analytics/services/analytics-api.service';
import { AddRateCardItemsModalComponent } from './components/add-rate-card-items-modal/add-rate-card-items-modal.component';
import { AddSupplierRateCardFileModalComponent } from './components/add-supplier-rate-card-file-modal/add-supplier-rate-card-file-modal.component';
import { DmartSupplierComponent } from './components/dmart-supplier/dmart-supplier.component';
import { HyperpureCartIframeComponent } from './components/hyperpure-cart-iframe/hyperpure-cart-iframe.component';
import { HyperpureSupplierComponent } from './components/hyperpure-supplier/hyperpure-supplier.component';
import { LocalSupplierPurchaseOrderModalComponent } from './components/local-supplier-create-po/local-supplier-purchase-order-modal.component';
import { PmAnalyticsDashboardComponent } from './components/pm-analytics-dashboard/pm-analytics-dashboard.component';
import { PmLandingComponent } from './components/pm-landing/pm-landing.component';
import { PmOrdersComponent } from './components/pm-orders/pm-orders.component';
import { PmPriceDiscoveryComponent } from './components/pm-price-discovery/pm-price-discovery.component';
import { PmSuppliersComponent } from './components/pm-suppliers/pm-suppliers.component';
import { UdaanSupplierComponent } from './components/udaan-supplier/udaan-supplier.component';
import { PurchaseManagerRoutingModule } from './purchase-manager-routing.module';

/**
 * The Angular module for the Purchase Manager feature.
 * This module handles the landing page, price discovery searches, supplier listings, and order history.
 */
@NgModule({
    declarations: [
        PmLandingComponent,
        PmOrdersComponent,
        PmPriceDiscoveryComponent,
        PmSuppliersComponent,
        LocalSupplierPurchaseOrderModalComponent,
        AddSupplierRateCardFileModalComponent,
        AddRateCardItemsModalComponent,
        PmAnalyticsDashboardComponent,
        HyperpureSupplierComponent,
        HyperpureCartIframeComponent,
        DmartSupplierComponent,
        UdaanSupplierComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        PurchaseManagerRoutingModule,
        SharedModule,
        DragDropModule,
        PurchaseManagerAnalyticsModule.forRoot({
            debugMode: !(environment as any).production,
            syncIntervalMs: 5 * 60 * 1000,
            maxPendingEvents: 500,
            maxStorageSizeBytes: 2 * 1024 * 1024,
        })
    ],
    providers: [
        AnalyticsApiService
    ],
    exports: [
        HyperpureCartIframeComponent
    ]
})
export class PurchaseManagerModule { }
